import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReadMoreComponent } from './read-more.component';

@NgModule({
    declarations: [
        ReadMoreComponent
    ],
    imports: [
        FormsModule,
        CommonModule
    ],
    exports: [
        ReadMoreComponent
    ]
})
export class ReadMoreModule {
}
